export default {
    methods: {
        formatRate(rate) {
            // 9 -> 9.00, 8.4 -> 8.40, 9.2344-> ==
            if (!rate) return "";
            if ((`${rate}`.split(".")[1]?.length || 0) < 3) return `${(Math.round(rate * 100) / 100).toFixed(2)} %`
            return `${rate} %`;
        },
    },
};
